import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { Link } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import server, { uploadServer } from "../../api/server";
import { useForm } from "react-hook-form";
import { handleImage } from "../../helpers";

const WhyUsIndex = () => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const dispatch = useDispatch();

	const onStart = async () => {
		dispatch(
			updateMeta({
				title: "لماذا نحن ؟",
				breadcrumb: "لماذا نحن ؟",
				button: {
					show: false,
					text: "اضافة نوع جديدة",
					link: "/type/create",
				},
			})
		);
		try {
			const pageData = await server(cookie).get("/pages/why-us");
			setData(pageData.data.data.page.sections);
			setLoading(false);
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة لاحقا!");
			setLoading(false);
		}
	};

	useEffect(() => {
		onStart();
	}, []);
	return (
		<section>
			{loading && <Loader />}
			<section>
				<div className="row">
					{data
						?.filter(e => e?.slug != "background")
						.map(post => (
							<div className="col-md-3" key={post.slug}>
								<div className="serviceItem">
									<Link to={`/siteinfo/whyUs/show/${post.slug}`}>
										<img
											src={`${process.env.REACT_APP_MAIN_URL}/${post.icon}`}
											alt={post.title ?? ""}
										/>
										<h1>{post.title ?? ""}</h1>
									</Link>
								</div>
							</div>
						))}
				</div>
				<ImageForm
					background={data?.find(e => e?.slug == "background")?.image}
				/>
			</section>
		</section>
	);
};

const ImageForm = ({ background }) => {
	const [loading, setLoading] = useState(false);

	const [pictureImg, setPictureImg] = useState(background);

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		setValue,
		getValues,
		reset,
	} = useForm();

	const submitHandler = async data => {
		setLoading(true);
		try {
			const dataForm = new FormData();
			dataForm.append("file", data.pictureUrl[0]);

			const imageResponse = await uploadServer(cookie).post(
				"/upload",
				dataForm
			);

			const finalData = {
				title: `${data?.nameEn} category`,
				name: {
					ar: data?.nameAr,
					en: data?.nameEn,
				},
				image: imageResponse.data.data.file.path,
			};

			const dataResponse = await server(cookie).put(
				"/pages/why-us/sections/background",
				{
					section: finalData,
				}
			);
			reset();
			setPictureImg(background);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	const handlePicture = () => {
		const tempValue = getValues("pictureUrl");
		if (tempValue.length < 1) return;
		const blobUrl = URL?.createObjectURL(tempValue?.[0]);
		setValue("picturePath", blobUrl);
		setPictureImg(blobUrl);
	};

	return (
		<form onSubmit={handleSubmit(submitHandler)}>
			{loading && <Loader />}
			<div className="row">
				<div className="col-md-12">
					<div className="card">
						{/* <div className="card-body">
							<div className="form-item">
								<label htmlFor="nameAr">اسم الفئة باللغة العربية</label>
								<input
									type="text"
									name="name"
									id="nameAr"
									{...register("nameAr", {
										required: true,
									})}
								/>
							</div>
						</div>
						<div className="card-body">
							<div className="form-item">
								<label htmlFor="nameEn">اسم الفئة بالغة الانجليزية</label>
								<input
									type="text"
									name="name"
									id="nameEn"
									{...register("nameEn", {
										required: true,
									})}
								/>
							</div>
						</div> */}
					</div>
				</div>
				<div className="col-md-12">
					<div className="card">
						<div className="card-body">
							<div className="form-item">
								<label htmlFor="picture">الخلفية</label>
								<input
									type="file"
									id="picture"
									{...register("pictureUrl", {
										required: true,
										onChange: () => handlePicture(),
									})}
									accept="image/*"
								/>
								<img
									src={handleImage(pictureImg || background)}
									alt="avatar"
									className="imagePreview-2"
								/>
							</div>
						</div>
					</div>
					<input
						type="text"
						name=""
						id=""
						style={{ display: "none" }}
						{...register("picturePath")}
					/>
					<div className="form-item mt-3">
						<button className="bt bt-success btn-block">ارسال</button>
					</div>
				</div>
			</div>
		</form>
	);
};

export default WhyUsIndex;
